import React from 'react';
import {
  Checkbox,
  FormControlLabel,
  Typography,
  useTheme,
} from '@mui/material';
import { useIntl } from 'react-intl';

import { IFacetSection } from 'api/catalog/models';
import { toTitleCase } from 'utils/toTitleCase';

import messages from '../messages';

export const getLabelClasses = (isSelectAll = false) => ({
  '& .MuiFormControlLabel-label': {
    fontSize: '.85rem',
    fontWeight: isSelectAll ? 'bold' : 'normal',
  },
  display: 'block',
});

interface IProps {
  facetSection: IFacetSection;
  isSelected?: (facetCode: string) => boolean;
  selectedCount?: number;
  onChangeSelection?: (facets: string[]) => void;
  onChangeSelectAll?: (allFacets: string[]) => void;
}

const FacetSection = ({
  facetSection,
  isSelected = () => false,
  selectedCount = 0,
  onChangeSelection = () => null,
  onChangeSelectAll = () => null,
}: IProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const { values: facets } = facetSection;
  return (
    <>
      <FormControlLabel
        sx={getLabelClasses(true)}
        control={
          <Checkbox
            size='small'
            checked={
              facets !== undefined &&
              selectedCount > 0 &&
              selectedCount === facets.length
            }
            onChange={
              facets
                ? () => onChangeSelectAll(facets.map((facet) => facet.value))
                : undefined
            }
            indeterminate={
              facets && selectedCount > 0 && selectedCount !== facets.length
            }
          />
        }
        label={formatMessage(messages.selectAll)}
      />
      {facets?.map((facet) => (
        <React.Fragment key={facet.value}>
          <FormControlLabel
            sx={getLabelClasses(false)}
            key={facet.value}
            control={
              <Checkbox
                size='small'
                checked={isSelected(facet.value)}
                onChange={() => onChangeSelection([facet.value])}
              />
            }
            label={
              <>
                {toTitleCase(facet.displayValue)}
                <Typography
                  variant='subtitle2'
                  component='span'
                  sx={{
                    display: 'inline-block',
                    marginLeft: '10px',
                    fontSize: '.75rem',
                    color: theme.palette.grey[500],
                  }}
                >
                  ({facet.count})
                </Typography>
              </>
            }
          />
        </React.Fragment>
      ))}
    </>
  );
};

export default FacetSection;
